// extracted by mini-css-extract-plugin
export default {"root":"SavedSearches_root__J18zh","savedSearches":"SavedSearches_savedSearches__e9NC4","actions":"SavedSearches_actions__z8tYP","button":"SavedSearches_button__HJHEJ"};